var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c(
      "div",
      { staticClass: "card setting-card" },
      [
        _c("div", { staticClass: "page-header" }, [
          _c("h3", { staticClass: "page-title" }, [
            _vm._v(
              _vm._s(
                _vm.$t("profile.financial_facilities.financial_facilities")
              )
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-header" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-8" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-4 d-flex flex-row-reverse" },
              [
                _c(
                  "base-button",
                  {
                    staticClass: "add-new-tax",
                    attrs: { outline: "", color: "theme" },
                    on: { click: _vm.addFinancialFacility },
                  },
                  [
                    _vm._v(
                      "\n                  " +
                        _vm._s(_vm.$t("profile.financial_facilities.add_new")) +
                        "\n                  "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "table-component",
          {
            ref: "financialFacilityTable",
            staticClass: "mb-3",
            attrs: {
              "show-filter": false,
              data: _vm.financialFacilities,
              "table-class": "table tax-table",
            },
          },
          [
            _c("table-column", {
              attrs: {
                sortable: true,
                label: _vm.$t("profile.financial_facilities.s_no"),
                show: "s_no",
              },
            }),
            _vm._v(" "),
            _c("table-column", {
              attrs: {
                label: _vm.$t("profile.financial_facilities.amount"),
                show: "amount",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (row) {
                    return [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("profile.financial_facilities.amount")
                            ) +
                            " "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$utils.formatMoney(
                              row.amount,
                              _vm.defaultCurrency
                            )
                          ),
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("table-column", {
              attrs: {
                sortable: true,
                label: _vm.$t("profile.financial_facilities.facility_nature"),
                show: "facility_nature",
              },
            }),
            _vm._v(" "),
            _c("table-column", {
              attrs: {
                sortable: false,
                filterable: false,
                "cell-class": "action-dropdown",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (row) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("profile.financial_facilities.action"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-dropdown",
                        [
                          _c(
                            "a",
                            {
                              attrs: { slot: "activator", href: "#" },
                              slot: "activator",
                            },
                            [_c("dot-icon")],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-dropdown-item", [
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.editFinancialFacility(row)
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "dropdown-item-icon",
                                  attrs: { icon: ["fas", "pencil-alt"] },
                                }),
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.$t("general.edit")) +
                                    "\n                  "
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }